const action = {
    general: 'حدث خطأ أثناء تشغيل الإجراء. يرجى المحاولة لاحقًا.',
    sign_in_identifier_changed: 'لا يمكن للإجراء تغيير معرّف تسجيل الدخول المستخدم في هذا التحقق.',
};
export default Object.freeze(action);
